import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import PortalLayout from '../../components/PortalLayout';
import { getPublicKbArticle, sendKbFeedback, getPublicTicketProject } from '../../services/customerApi';
import { useLanguage } from '../../i18n/LanguageContext';

/** Articolo di aiuto pubblico (base di conoscenza), con il voto "ti è stato utile?". */
function PortalHelp() {
  const { t } = useLanguage();
  const { projectSlug, id } = useParams();
  const [article, setArticle] = useState(null);
  const [project, setProject] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [voted, setVoted] = useState(false);

  useEffect(() => {
    getPublicKbArticle(projectSlug, id).then((d) => setArticle(d.article)).catch(() => setNotFound(true));
    getPublicTicketProject(projectSlug).then((d) => setProject(d.project)).catch(() => {});
  }, [projectSlug, id]);

  const vote = async (helpful) => {
    setVoted(true);
    try {
      await sendKbFeedback(projectSlug, id, helpful);
    } catch (err) {
      // il voto è accessorio: se non parte non si disturba il cliente
    }
  };

  return (
    <PortalLayout title={article?.title || t('portal.kbArticle')} subtitle={article?.category || undefined} accent={project?.color}>
      <div className="card">
        <div className="card-body">
          {notFound && <p>{t('portal.kbNotFound')}</p>}
          {article && <div className="portal-kb-body">{article.body}</div>}
          {article && (
            <div className="portal-kb-vote">
              {voted ? <span>{t('portal.kbThanks')}</span> : (
                <>
                  <span>{t('portal.kbHelpful')}</span>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => vote(true)}>{t('portal.kbYes')}</button>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => vote(false)}>{t('portal.kbNo')}</button>
                </>
              )}
            </div>
          )}
          <p style={{ marginTop: 16 }}><Link to={`/portal/${projectSlug}`}>{t('portal.kbBack')}</Link></p>
        </div>
      </div>
    </PortalLayout>
  );
}

export default PortalHelp;
